import React from "react";
import { useI18n } from "../lib/i18n";
import { ChevronDown, Languages } from "lucide-react";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const LanguageSelector = () => {
    const { lang, setLang, languages } = useI18n();
    const current = languages[lang];
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    data-testid="language-selector"
                    className="flex items-center gap-1.5 border border-soft px-2 py-1.5 text-xs font-semibold hover:border-amber"
                >
                    <Languages size={12} />
                    <span className="text-base leading-none">{current.flag}</span>
                    <ChevronDown size={11} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-elev border-strong" style={{ background: "var(--bg-elev)", borderColor: "var(--border-strong)" }}>
                {Object.values(languages).map(l => (
                    <DropdownMenuItem
                        key={l.code}
                        data-testid={`lang-${l.code}`}
                        onClick={() => setLang(l.code)}
                        className={`cursor-pointer text-xs ${lang === l.code ? "text-amber" : ""}`}
                        style={lang === l.code ? { color: "var(--amber)" } : undefined}
                    >
                        <span className="w-6 text-base">{l.flag}</span>
                        <span>{l.label}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
